export const includesProtocol = (url) => {
  return /^https?:\/\//.test(url)
}

export const normalizeUrl = (url) => {
  if (!includesProtocol(url)) {
    return `https://${url}`
  } else {
    return url
  }
}

export const isValidAbsoluteUrl = (url) => {
  const urlRegex =
    /^(https?:\/\/)(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=]*)?$/
  return urlRegex.test(url)
}

export const safeConcatPath = (str1, str2) => {
  const trimmedStr1 = str1.endsWith('/') ? str1.slice(0, -1) : str1
  const trimmedStr2 = str2.startsWith('/') ? str2.slice(1) : str2
  return `${trimmedStr1}/${trimmedStr2}`
}
